import { useTranslation } from "react-i18next";
import { useBisacCatalogueQuery } from "components/BisacCodes/hooks/useBisacCatalogueQuery";
import { InfoTooltip } from "components/InfoTooltip";
import { TabHeader } from "components/TabHeader";

export const BisacCodesHeader = () => {
  const { t } = useTranslation("bisacCodes");
  const edition = useBisacCatalogueQuery().data?.edition;

  return (
    <TabHeader
      title={t("bisacCodes:header.title")}
      subtitle={
        <span className="inline-flex items-center gap-1">
          {t("bisacCodes:header.description")}
          {edition && (
            <InfoTooltip
              label={t("bisacCodes:header.editionLabel")}
              text={t("bisacCodes:header.edition", { edition })}
              iconSize="small"
            />
          )}
        </span>
      }
    />
  );
};
